import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeCheckoutForm from "../components/StripeCheckoutForm";
import { ReactComponent as Spinner } from "../assets/images/spinner.svg";
import VoucherSection from "./VoucherSection";
import { optionsStripeCheckout } from "../utils/constants";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

export default function PaymentForm ({
    setAmount,
    prescription,
    amount,
    user,
    setCurrentStep,
    setStatus,
    steps,
    setSteps
  }) {
  const [country, setCountry] = useState("");
  const { t, i18n } = useTranslation();
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);
  const [appliedVoucher, setAppliedVoucher] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFree, setIsFree] = useState(false);
  

  const fetchVoucher = async (voucherCode) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/user/apply-coupon`,
        { id: prescription._id, voucher: voucherCode },
        { withCredentials: true }
      );

      setAmount(prevAmount => {
        if (!data.isValid) return { ...prevAmount }; 

        const discountedAmount = data.discountedAmount;
        const totalAmount = prevAmount.amount - data.discountedAmount;
        
        setAppliedVoucher(voucherCode);
        return {
          ...prevAmount,
          amountDiscounted: discountedAmount,
          amountTotal: totalAmount,
          voucher: voucherCode,
          isValid: data.isValid
        };
      });

      return { ...data }
      
    } catch (error) {
      console.error("Erro ao criar payment intent:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: t("Please, insert a valid voucher"),
      });
      setLoading(false);
    }
  };
  

  const handleApplyVoucher = async (voucherCode) => {
    const result = await fetchVoucher(voucherCode);
    if (result && result.isValid) {
      setAppliedVoucher(voucherCode);
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: t("Please, insert a valid voucher"),
      });
    }
  };

  const fetchPaymentIntent = async () => {
    const token = prescription._id;
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/user/create-payment-intent`,
        { lng: i18n.language, token, voucher: appliedVoucher },
        { withCredentials: true }
      );

      if (data.isFree) {
        handlePaymentComplete();
      } else {
        setClientSecret(data.clientSecret);
      }
    } catch (error) {
      console.error("Erro ao criar payment intent:", error);
      setLoading(false);
    }
  };

  const handleContinue = async () => {
    setLoading(true);
    await fetchPaymentIntent();
    setShowPaymentMethod(true);
    setLoading(false);
  };

  useEffect(() => {
    const fetchCountry = async () => {
      let country = localStorage.getItem("country");

      if (!country) {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        country = data.country_code;
        localStorage.setItem("country", country);
      } 
      setCountry(country);
    };

    const getCodeParameter = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      if (code) {
        handleApplyVoucher(code);
      }
    }

    fetchCountry();
    getCodeParameter();
  }, []);

  const handlePaymentComplete = () => {
    console.log('handlePaymentComplete');
    setCurrentStep(4);
    setStatus("expert-validation");
    const updatedSteps = [...steps];

    updatedSteps.forEach((oldStep, index) => {
      if (oldStep.id < 4) updatedSteps[index].completed = true;
    });
    setSteps(updatedSteps);
    
    Swal.fire({
      icon: "success",
      title: t("Payment successful"),
      text: t("Your payment has been processed and your prescription will be validated by our experts"),
    });
  };

  const options = {
    ...optionsStripeCheckout,
    clientSecret
  };

  return (
    <>
      <div className="payment-text-form">
        <div className="payment-text-form-left">
          {i18n.language !== "pt-BR" && (<div className="payment-text">
          <h2 className="results-title">{t("Test completed successfully.")}</h2>
          <p>
            {t("Now that your test is complete, your results will be sent to a specialist for validation and review. Once finalized, your prescription will be generated and issued.")}
          </p>
          <p>
            {t("Continue to proceed to checkout and get a step closer to your new eyewear prescription.")}
          </p>
          </div>)}

          {i18n.language === "pt-BR" && (<div className="payment-text">
            
            <h2 className="results-title">{t("texto payment1")}</h2><br />
            <p>
              {t("Now that your test is complete, your results will be sent to a specialist for validation and review. Once finalized, your prescription will be generated and issued.")} {t("texto payment2")}</p>
            <br />
            <h4><strong>{t("texto payment3")}</strong></h4>
            <br />
            <p>{t("texto payment4")}</p>
            <p><strong>{t("texto payment5")}</strong></p>
            <p><strong>{t("texto payment6")}</strong></p>
            <p><strong>{t("texto payment7")}</strong></p>
          </div>)}
        </div>
        
        <div className="results-section">
          {!loading && clientSecret && showPaymentMethod && amount.amount && (
            <Elements options={options} stripe={stripePromise}>
              <StripeCheckoutForm onPaymentComplete={handlePaymentComplete} amount={amount} user={user} country={country} clientSecret={clientSecret} setShowPaymentMethod={setShowPaymentMethod} appliedVoucher={appliedVoucher}/>
            </Elements>
          )}
          {!loading && !showPaymentMethod && <VoucherSection amount={amount} handleContinue={handleContinue} onApplyVoucher={handleApplyVoucher} />}
          {loading && <div className="loading-container" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px'}}><Spinner /></div>}
        </div>
      </div>
    </>
)};